import { apiClient, publicApiClient } from "./apiClient";

const DATA_API_PATH = {
  stdcouncil: "/api/doc/council",
  central: "/api/doc/executive",
  audit: "/api/doc/audit",
  etc: "/api/doc/etc",
  delegate: "/api/doc/certificate",
};

const getPath = (category) => {
  const path = DATA_API_PATH[category];

  if (!path) {
    throw new Error(`지원하지 않는 자료실 category입니다: ${category}`);
  }

  return path;
};

const getCouncilDocListCategory = (dataFilterType) => {
  if (!dataFilterType || dataFilterType === "all") return "ALL";
  if (dataFilterType === "rule") return "CONSTITUTION";
  if (dataFilterType === "bylaw") return "BYLAW";
  return "ALL";
};

const getFormListCategory = (dataFilterType) => {
  if (!dataFilterType || dataFilterType === "all") return "ALL";
  if (dataFilterType === "accounting") return "BUDGET";
  if (dataFilterType === "event") return "EVENT";
  if (dataFilterType === "admin") return "ADMINISTRATION";
  if (dataFilterType === "etc") return "ETC";
  return "ALL";
};

// 목록 조회
export const getDataList = async ({
  category,
  activeDataType = "data",
  dataFilterType = "all",
  searchCategory = "TITLE",
  keyWord = "",
  page = 0,
  size = 10,
}) => {
  const params = new URLSearchParams();

  params.append("searchCategory", searchCategory);
  params.append("page", page);
  params.append("size", size);

  if (keyWord) {
    params.append("keyWord", keyWord);
  }

  let url = getPath(category);

  if (category === "stdcouncil") {
    if (activeDataType === "form") {
      url = `${url}/forms`;
      params.append("listCategory", getFormListCategory(dataFilterType));
    } else {
      url = `${url}/docs`;
      params.append("listCategory", getCouncilDocListCategory(dataFilterType));
    }
  }

  const result = await publicApiClient(`${url}?${params.toString()}`, {
    method: "GET",
  });

  return result.data;
};

// 상세 조회
export const getDataDetail = async (category, id) => {
  const result = await publicApiClient(`${getPath(category)}/${id}`, {
    method: "GET",
  });

  return result.data;
};

// 등록
export const createData = async (category, data, files = []) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  files.forEach((file) => {
    formData.append("files", file);
  });

  const result = await apiClient(getPath(category), {
    method: "POST",
    body: formData,
  });

  return result.data;
};

// 수정
export const updateData = async (
  category,
  id,
  data,
  files = [],
  keepFileIds = []
) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  keepFileIds.forEach((fileId) => {
    formData.append("keepFileIds", fileId);
  });

  files.forEach((file) => {
    formData.append("files", file);
  });

  const result = await apiClient(`${getPath(category)}/${id}`, {
    method: "PUT",
    body: formData,
  });

  return result.data;
};

// 삭제
export const deleteData = async (category, id) => {
  const result = await apiClient(`${getPath(category)}/${id}`, {
    method: "DELETE",
  });

  return result.data;
};